// extracted by mini-css-extract-plugin
module.exports = {"image":"image_image__2FzTx","imageLoaded":"image_image--loaded__1QAMQ"};